<template>
	<div class="item-listing" tabindex="0" @keydown.esc="closePopup()">
		<div class="container">
<!--			<p class="minimun-notification product-post__prep">{{ minimumAmount }}</p>-->
<!--			<div class="item-listing__view-switch">-->
<!--				<div class="item-listing__view-switch-box">-->
<!--					<div class="item-listing__view-switch-btns">-->
<!--						<span class="item-listing__view-switch-rows item-listing__view-btns"-->
<!--							  :class="listView ? 'switch-active' : ''"-->
<!--							  @click="changeToListView"-->
<!--						>-->
<!--							<SvgIcon class="item-listing__view-switch-ico" iconName="ico-list"/>-->
<!--						</span>-->

<!--						<span class="item-listing__view-switch-boxes item-listing__view-btns"-->
<!--							  :class="boxView ? 'switch-active' : ''"-->
<!--							  @click="changeToBoxView"-->
<!--						>-->
<!--							<SvgIcon class="item-listing__view-switch-ico" iconName="ico-image-regular"/>-->
<!--						</span>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->

			<div class="item-listing__wrap item-listing__container js-item-listing-wrap"
				 :class="listView ? 'item-listing__mobile-prod' : ''"
				 v-if="!noResults"
			>

				<template v-for='(product, index) in products'>
					<PartProductPost
						:key="index"
						:product='product'
						:productPopupID="productPopupID"
						hasFeeds
						imgName='food-1.jpg'
						@click='handleClick(index, $event, product.type)'
					/>
				</template>
			</div>

			<div class="item-listing__wrap item-listing__container no-products-found-wrap js-item-listing-wrap" v-else>
				Looks like that's missing from our pantry.
			</div>

			<div v-if="showSpinner" class="spinner-container">
				<SvgIcon class="ico-spinner color-happy-blue" iconName="ico-spinner"/>
			</div>
		</div>
		<BlockPopupProduct :show="show" v-on:changeShow="changeShow" :product="product" @click="show = $event"/>
	</div><!-- .item-listing -->
</template>

<script>
import PartProductPost from '../parts/PartProductPost.vue';
import BlockPopupProduct from './BlockPopupProduct.vue';
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

export default {
	props: {
		type: String
	},

	mounted() {
		const type = this.type === 'package' ? 'package' : 'regular';
		// eslint-disable-next-line no-unused-vars
		const products = this.$store.dispatch('setProducts', {type: type, category: this.categoryFlag, page: 1});
		const url = window.location.href;
		if (url.includes('?product-popup')) {
			const productID = url.split('?product-popup=');
			this.productPopupID = productID[1];

			setTimeout(function(){
				const firstRadio = document.querySelectorAll('.popup-product__radio');
				if(firstRadio[0]) {
					firstRadio[0].click();
				}
			}, 500);
		}

		if (window.innerWidth <= 767) {
			this.boxView = false;
			this.listView = true;
		}
	},
	// created() {
	// 	window.addEventListener('scroll', this.handleScroll);
	// },
	// destroyed() {
	// 	window.removeEventListener('scroll', this.handleScroll);
	// },
	components: {
		PartProductPost,
		SvgIcon,
		BlockPopupProduct
	},

	data() {
		return {
			product: {},
			products: [],
			selectedProduct: {},
			show: false,
			showSpinner: true,
			scrollPosition: 0,
			// eslint-disable-next-line no-undef
			categoryFlag: productsCategory,
			// eslint-disable-next-line no-undef
			minimumAmount: minimumOrderNotification,
			noResults: false,
			productPopupID: 0,
			boxView: true,
			listView: false,
			loadMore: true,
			page: 2,
		};
	},

	computed: {
		allProducts() {
			return this.$store.getters.getProducts;
		},
		dropDowns() {
			return this.$store.getters.getFilterDropdown;
		},
		getChosenFilterDishType() {
			return this.$store.getters.getChosenFilterDishType;
		},
		getChosenFilterEventType() {
			return this.$store.getters.getChosenFilterEventType;
		},
		getChosenFilterPeople() {
			return this.$store.getters.getChosenFilterPeople;
		},
		getChosenFilterPrice() {
			return this.$store.getters.getChosenFilterPrice;
		}
	},

	methods: {
		//  async handleScroll(event) {
		// 	if (this.loadMore && this.page <= 1) {
		// 		const type = this.type === 'package' ? 'package' : 'regular';
		// 		this.loadMore = false;
		// 		await this.$store.dispatch('setProducts', {type: type, category: this.categoryFlag, page: this.page})
		// 		.then(response => {
		// 			this.loadMore = true;
		// 			this.page++;
		// 		}).catch(error => {
		// 			console.log(error);
		// 		});
		// 	}
		// },
		changeToListView() {
			this.boxView = false;
			this.listView = true;
		},
		changeToBoxView() {
			this.boxView = true;
			this.listView = false;
		},
		changeShow() {
			this.show = !this.show;
		},
		closePopup() {
			this.show = false;
		},
		handleClick(index, event, type) {
			if (type !== 'package') {
				this.show = event;
				this.selectProduct(index);
			}
		},
		selectProduct(productOrder) {
			this.product = this.products[productOrder];
		}
	},

	watch: {
		show() {
			if (this.show) {
				const $body = document.querySelector('body');
				$body.classList.add('body-lock');
				this.scrollPosition = window.pageYOffset;
				$body.style.overflow = 'auto';
				$body.style.position = 'fixed';
				$body.style.top = `-${this.scrollPosition}px`;
				$body.style.width = '100%';
				return;
			}
			const $body = document.querySelector('body');
			$body.classList.remove('body-lock');
			$body.style.removeProperty('overflow');
			$body.style.removeProperty('position');
			$body.style.removeProperty('top');
			$body.style.removeProperty('width');
			window.scrollTo(0, this.scrollPosition);
		},
		allProducts(newVal) {
			let largestPrice = 0;
			let largestServing = 0;
			let types = [];
			if (newVal.length > 0) {
				this.noResults = false;
				const tags = [];
				newVal.forEach((element) => {
					if (element.tag !== false && !tags.includes(element.tag)) {
						if (element.tag.includes(',')) {
							const multipleTag = element.tag.split(',');
							multipleTag.forEach((item) => {
								if (!tags.includes(item)) {
									tags.push(item);
								}
							});
						} else {
							tags.push(element.tag);
						}
					}
					if (element.event !== false && !types.includes(element.event)) {
						if (element.event.includes(',')) {
							const multipleEvent = element.event.split(',');
							multipleEvent.forEach((item) => {
								if (!types.includes(item.trim())) {
									types.push(item.trim());
								}
							});
						} else {
							types.push(element.event.trim());
						}
					}
					if (largestPrice < parseFloat(element.price)) {
						largestPrice = element.price;
					}
					if (largestServing < parseFloat(element.serving_middle_number)) {
						largestServing = element.serving_middle_number;
					}
				});
				types = types.filter(function(el) {
					return el !== '';
				});
				this.$store.dispatch('setLargestPrice', largestPrice);
				this.$store.dispatch('setTags', tags);
				this.$store.dispatch('setLargestServing', largestServing);
				this.$store.dispatch('setTypes', types);
			} else {
				this.noResults = true;
			}

			this.showSpinner = false;
			this.products = newVal;
		}
	}
};
</script>

<style lang="scss" scoped>
.item-listing {
	margin-top: 55px;

	@include mq($sm) {
		margin-top: 10px;
	}
}

.item-listing__wrap {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	align-content: stretch;
	transition: 350ms ease;
}

.spinner-container {
	margin-top: 10px;
	display: flex;
	justify-content: center;
}

.ico-spinner {
	font-size: 26px;
	animation-name: spinner-rotation;
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}

@keyframes spinner-rotation {
	0% {
		transform: rotate(0);
	}

	100% {
		transform: rotate(1turn);
	}
}

.no-products-found-wrap {
	align-items: center;
	justify-content: center;
	color: #ff7534;
	font-size: 22px;
}

.item-listing__view-switch {
	display: none;

	@include mq($md) {
		display: block;
	}
}

.item-listing__view-switch-btns {
	display: flex;
	justify-content: flex-end;
}

.item-listing__view-btns {
	width: 100%;
	max-width: 46px;
	height: 32px;
	background-color: $white;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid rgba(97, 143, 175, 0.4);
	transition: 350ms ease;

	.item-listing__view-switch-ico {
		font-size: 15px;
		color: #628fb0;
		transition: 350ms ease;
	}
}

.item-listing__view-switch-rows {
	cursor: pointer;
	border-top-left-radius: 6px;
	border-bottom-left-radius: 6px;
}

.item-listing__view-switch-boxes {
	cursor: pointer;
	border-top-right-radius: 6px;
	border-bottom-right-radius: 6px;
}

.switch-active {
	background-color: #628fb0;
	transition: 350ms ease;

	.item-listing__view-switch-ico {
		color: $white;
		transition: 350ms ease;
	}
}

.item-listing__view-switch-box {
	margin-bottom: 10px;
}
/** todo: refactor */
.minimun-notification {
	display: block;
	position: relative;
	z-index: 1;
	padding: 4px 12px;
	border-radius: 4px;
	color: #ff7534;
	background-color: #ffe7dc;
	font-family: Livory, Georgia, serif;
	font-size: 15px;
	box-shadow: 5px 8px 15px rgba(31, 66, 94, .07);
	margin: -40px auto 40px;
	text-align: center;
	width: 230px;
}

@media screen and (max-width: 575px)  {
	.minimun-notification {
		margin: 0 auto 40px;
	}
}
</style>
